import { render, staticRenderFns } from "./serviceSection.vue?vue&type=template&id=2156aee5&scoped=true&"
import script from "./serviceSection.vue?vue&type=script&lang=js&"
export * from "./serviceSection.vue?vue&type=script&lang=js&"
import style0 from "./serviceSection.vue?vue&type=style&index=0&id=2156aee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156aee5",
  null
  
)

export default component.exports